const CREDIT_STATUS_FIELDS = gql`
  fragment LlmCreditStatusFields on LlmCreditStatus {
    weeklyTokenLimit
    weeklyTokensUsed
    weeklyTokensRemaining
    bonusTokensRemaining
    totalTokensRemaining
    usageRatio
    warningThresholdReached
    locked
    paymentMethodRequired
    paymentMethodCreditLimit
    unlimited
    weekStartsAt
    weekEndsAt
  }
`;

export const LLM_CHAT_START_MUTATION = gql`
  mutation LlmChatStartMutation(
    $integrationId: String!
    $message: String!
    $threadId: String
    $resetContext: Boolean
    $displayMessage: String
    $displayKind: String
    $displayPayload: JSON
    $threadTitle: String
  ) {
    llmChatStart(
      integrationId: $integrationId
      message: $message
      threadId: $threadId
      resetContext: $resetContext
      displayMessage: $displayMessage
      displayKind: $displayKind
      displayPayload: $displayPayload
      threadTitle: $threadTitle
    ) {
      runId
      threadId
      status
    }
  }
`;

export const LLM_CHAT_ARCHIVE_THREAD_MUTATION = gql`
  mutation LlmChatArchiveThreadMutation($threadId: String!) {
    llmChatArchiveThread(threadId: $threadId)
  }
`;

export const LLM_CHAT_RUN_QUERY = gql`
  query LlmChatRunQuery($runId: String!) {
    llmChatRun(runId: $runId) {
      id
      threadId
      integrationId
      integrationName
      integrationDomain
      threadTitle
      status
      progressMessage
      userMessage
      userDisplayMessage
      userDisplayKind
      userDisplayPayload
      assistantMessage
      assistantDisplayKind
      assistantDisplayPayload
      error
    }
  }
`;

export const LLM_CHAT_SESSIONS_QUERY = gql`
  query LlmChatSessionsQuery($integrationId: String!, $limit: Int) {
    llmChatSessions(integrationId: $integrationId, limit: $limit) {
      id
      integrationId
      title
      lastMessageAt
      createdAt
      updatedAt
    }
  }
`;

export const LLM_CHAT_STATE_QUERY = gql`
  ${CREDIT_STATUS_FIELDS}

  query LlmChatStateQuery(
    $integrationId: String!
    $threadId: String
    $limit: Int
  ) {
    llmChatState(
      integrationId: $integrationId
      threadId: $threadId
      limit: $limit
    ) {
      thread {
        id
        integrationId
        title
        lastMessageAt
        createdAt
        updatedAt
      }
      messages {
        id
        runId
        role
        content
        displayKind
        displayPayload
        status
        createdAt
      }
      activeRun {
        id
        threadId
        integrationId
        integrationName
        integrationDomain
        threadTitle
        status
        progressMessage
      }
      creditStatus {
        ...LlmCreditStatusFields
      }
      sourcesOfTruth {
        id
        label
        type
      }
    }
  }
`;

// Backward-compatible exports for older components/tests.
export const LLM_CHAT_CLEAR_THREAD_MUTATION = gql`
  mutation LlmChatClearThreadMutation($integrationId: String!) {
    llmChatClearThread(integrationId: $integrationId)
  }
`;

export const LLM_CHAT_THREAD_QUERY = gql`
  query LlmChatThreadQuery($integrationId: String!, $limit: Int) {
    llmChatThread(integrationId: $integrationId, limit: $limit) {
      threadId
      messages {
        id
        runId
        role
        content
        status
        createdAt
      }
    }
  }
`;

export const LLM_CHAT_STATUS_QUERY = gql`
  ${CREDIT_STATUS_FIELDS}

  query LlmChatStatusQuery($integrationId: String) {
    llmChatStatus(integrationId: $integrationId) {
      activeRun {
        id
        threadId
        integrationId
        integrationName
        integrationDomain
        threadTitle
        status
        progressMessage
      }
      creditStatus {
        ...LlmCreditStatusFields
      }
    }
  }
`;
